import {useEffect, useState} from 'react'
import CodeMirror from '@uiw/react-codemirror';


import {javascript} from '@codemirror/lang-javascript';
import {html} from "@codemirror/lang-html";
import Button from "../button";


const Code = (
    {
        name, value, label, placeholder, containerClass, className,
        error, required, tools, lang, isReady, blurFunction, hasErrors, ...rest
    }) => {

    const language = lang ? lang : "HTML"
    const [inputValue, setInputValue] = useState('')
    const [fullScreen, setFullScreen] = useState(false)


    const CodeExtensions = [
        html({
            matchClosingTags: true,
            autoCloseTags   : true
        }),
        javascript({
            jsx: false
        })
    ]


    const handleChange = (content) => {
        setInputValue(content)
    }

    const handleFullScreen = (ev) => {
        ev.preventDefault()
        setFullScreen(!fullScreen)
    }


    useEffect(() => {
        setInputValue(value ?? '')
    }, [value])


    return (
        <div className={`form-group${containerClass ? ' ' + containerClass : ''}`}>
            {label && <label>
                {required && <span className="text-red required">* </span>}
                {label}
                {error && <span className="error">{error}</span>}
            </label>}
            <div className="input-container">
                <div className={fullScreen ? 'CodeEditor CodeFull' : 'CodeEditor'}>
                    {tools !== false && <div className="CodeTools">
                        <ul className="list-inline list-unstyled">
                            <li className="list-inline-item">
                                <Button
                                    size="sm"
                                    isReady={isReady}
                                    icon={!fullScreen ? "maximize" : "minimize"}
                                    label={!fullScreen ? "Maximize" : "Minimize"}
                                    onClick={handleFullScreen}
                                />
                            </li>
                        </ul>
                    </div>}

                    <div className={hasErrors ? 'has-errors' : ''}>
                        <CodeMirror
                            theme="light"
                            height="200px"
                            value={inputValue}
                            disabled={!isReady}
                            language={language}
                            indentWithTab={true}
                            onChange={handleChange}
                            placeholder={placeholder}
                            extensions={CodeExtensions}
                            onBlur={() => {
                                if (typeof blurFunction === 'function') {
                                    blurFunction(inputValue)
                                }
                            }}
                            {...rest}
                        />
                    </div>
                    <input type="hidden" name={name} value={inputValue}/>
                </div>
            </div>
        </div>
    )
}

export default Code;